import { useUserStore } from "./user";
import { useAppStore } from "./app";
import { useOrganizationStore } from "./organization";

let appStoreInstance;
let userStoreInstance;
let organizationStoreInstance;
export function getAppStore() {
  if (!appStoreInstance) {
    appStoreInstance = useAppStore();
  }
  return appStoreInstance;
}

export function getUserStore() {
  if (!userStoreInstance) {
    userStoreInstance = useUserStore();
  }
  return userStoreInstance;
}

export function getOrganizationStore() {
  if (!organizationStoreInstance) {
    organizationStoreInstance = useOrganizationStore();
  }
  return organizationStoreInstance;
}